import { axiosRequest } from './../../service/axios';

export const getList = () => {
  const url = 'dashboard/admin';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export default 'getList';
